import { Row, Col } from 'react-bootstrap'
import { ButtonLink } from '@/components/lib/ButtonLink'
import { UserListTable } from '@/components/entities/user/UserListTable'
import { useUserRole } from '@/hooks/useUserRole'
import { useOutletContext } from 'react-router-dom'
import React from 'react'

type ContextType = {
  setTitle: React.Dispatch<React.SetStateAction<string>>
}

export const UserList = () => {
  const { setTitle } = useOutletContext<ContextType>()
    const myRole = useUserRole();
  
    React.useEffect(() => {
      setTitle('Utilisateurs')
    }, [setTitle])
  /* Render
   *******************************************************************************************/
  return (
    <>
      <Row>
        <Col>
          {myRole === import.meta.env.VITE_APP_ROLE_SUPER_ADMIN && (
            <ButtonLink
              name={'Nouvel utilisateur'}
              href={'/utilisateurs/creation'}
              icon={'Plus'}
            />
          )}
        </Col>
      </Row>
      <Row className='mt-4'>
        <Col>
          <UserListTable />
        </Col>
      </Row>
    </>
  )
}
